import ROUTES from "../../../../configs/routesConfig";
import { Row } from "antd";
import { NavigateFunction, Location } from "react-router-dom";
import { ReactNode, useMemo, MouseEvent } from "react";
import { NavItem } from "../../../../types/NavItem";
import { Item } from "./Item";
import { useHasProcessingAccess } from "../../../../lib/PermissionContainer/hooks/useHasProcessingAccess";
import { useHasDashBoardAccess } from "../../../../lib/PermissionContainer/hooks/useHasDashboardAccess";
import { useHasReportsAccess } from "../../../../lib/PermissionContainer/hooks/useHasReportsAccess";
import { useGetRole } from "../../../../lib/hooks/getRole";
import USER_ROLES from "../../../../types/UserRoles";
import { useSelector } from "react-redux";

type NavItemsProps = {
  navigate: NavigateFunction;
  location: Location;
  setNextLocation: (value: MouseEvent<HTMLAnchorElement>) => void;
};

export const NavItems = ({ location, setNextLocation }: NavItemsProps) => {
  const { canViewProcessing } = useHasProcessingAccess();

  const { canViewDashboard } = useHasDashBoardAccess();

  const { canViewReports } = useHasReportsAccess();

  const [role] = useGetRole();

  const systemState = useSelector((state: any) => state.systemState);

  const items: NavItem[] = useMemo(() => {
    const values: NavItem[] = [
      {
        path: ROUTES.ACCOUNTS,
        name: "Accounts"
      },
      {
        path: ROUTES.CUSTOMERS,
        name: "Customers"
      },
      {
        path: ROUTES.USER_MANAGEMENT,
        name: "User Management"
      },
      {
        path: ROUTES.EMAILS,
        name: "Emails",
        notification: systemState.failedMailingsCount > 0
      }
    ];

    canViewDashboard &&
      [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN].includes(role) &&
      values.unshift({
        path: ROUTES.DASHBOARD,
        name: "Home"
      });

    canViewProcessing &&
      values.splice(4, 0, {
        path: ROUTES.PROCESSING,
        name: "Processing"
      });

    canViewReports &&
      values.push({
        path: ROUTES.REPORTS,
        name: "Reports"
      });

    return values;
  }, [canViewDashboard, canViewProcessing, canViewReports, role, systemState]);

  return (
    <Row>
      {items.map(
        (item: NavItem, i: number): ReactNode => (
          <Item key={i} item={item} location={location} setNextLocation={setNextLocation} />
        )
      )}
    </Row>
  );
};
